import { EChartColor } from '../../report/components/helperFunction';

export const gpsYAxis = ['speed', 'altitude', 'distance'];
export const gpsSchema = [
  {
    logKey: 'gps',
    dataKeys: ['speed'],
    seriesOption: {
      name: 'Speed',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
      tooltip: {
        valueSuffix: ' KM/H',
      },
    },
  },
  {
    logKey: 'gps',
    dataKeys: ['altitude'],
    seriesOption: {
      name: 'Altitude',
      type: 'spline',
      yAxis: 1,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.black,
      },
      lineColor: EChartColor.black,
      color: EChartColor.black,
    },
  },
  {
    logKey: 'gps',
    dataKeys: ['distance'],
    seriesOption: {
      name: 'Distance',
      type: 'spline',
      yAxis: 2,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
      tooltip: {
        valueSuffix: ' KM',
      },
    },
  },
];

export const rpmYAxis = ['rpm'];
export const rpmSchema = [
  {
    logKey: 'rpm',
    dataKeys: ['port', 'rpm'],
    seriesOption: {
      name: 'Port RPM',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
    },
  },
  {
    logKey: 'rpm',
    dataKeys: ['starboard', 'rpm'],
    seriesOption: {
      name: 'Starboard RPM',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.teal,
      },
      lineColor: EChartColor.teal,
      color: EChartColor.teal,
    },
  },
];

export const rpmPortSchema = [
  {
    logKey: 'rpm',
    dataKeys: ['port', 'rpm'],
    seriesOption: {
      name: 'Port RPM',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
    },
  },
];

export const rpmStarboardSchema = [
  {
    logKey: 'rpm',
    dataKeys: ['starboard', 'rpm'],
    seriesOption: {
      name: 'Starboard RPM',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.teal,
      },
      lineColor: EChartColor.teal,
      color: EChartColor.teal,
    },
  },
];

export const clutchYAxis = ['clutch'];
export const clutchPortSchema = [
  {
    logKey: 'clutch',
    dataKeys: ['port', 'clutch'],
    seriesOption: {
      name: 'Port Clutch',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
    },
  },
];

export const clutchStarboardSchema = [
  {
    logKey: 'clutch',
    dataKeys: ['starboard', 'clutch'],
    seriesOption: {
      name: 'Starboard Clutch',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.teal,
      },
      lineColor: EChartColor.teal,
      color: EChartColor.teal,
    },
  },
];

export const clutchCenterSchema = [
  {
    logKey: 'clutch',
    dataKeys: ['center', 'clutch'],
    seriesOption: {
      name: 'Center Clutch',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
    },
  },
];

export const fmYAxis = [
  'density',
  'volumeTotal',
  'volumeFlowRate',
  'massFlowRate',
  'massTotal',
  'temperature',
];
export const fmSchema = [
  {
    logKey: 'flowmeter',
    dataKeys: ['density'],
    seriesOption: {
      name: 'Density',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
    },
  },
  {
    logKey: 'flowmeter',
    dataKeys: ['volumeTotal'],
    seriesOption: {
      name: 'Volume Total',
      type: 'spline',
      yAxis: 1,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.blue,
      },
      lineColor: EChartColor.blue,
      color: EChartColor.blue,
    },
  },
  {
    logKey: 'flowmeter',
    dataKeys: ['volumeFlowrate'],
    seriesOption: {
      name: 'Volume Flow Rate',
      type: 'spline',
      yAxis: 2,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
    },
  },
  {
    logKey: 'flowmeter',
    dataKeys: ['massFlowrate'],
    seriesOption: {
      name: 'Mass Flow Rate',
      type: 'spline',
      yAxis: 3,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.yellow,
      },
      lineColor: EChartColor.yellow,
      color: EChartColor.yellow,
    },
  },
  {
    logKey: 'flowmeter',
    dataKeys: ['massTotal'],
    seriesOption: {
      name: 'Mass Total',
      type: 'spline',
      yAxis: 4,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.green,
      },
      lineColor: EChartColor.green,
      color: EChartColor.green,
    },
  },
  {
    logKey: 'flowmeter',
    dataKeys: ['temperature'],
    seriesOption: {
      name: 'Temperature',
      type: 'spline',
      yAxis: 5,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.blueDark,
      },
      lineColor: EChartColor.blueDark,
      color: EChartColor.blueDark,
    },
  },
];

export const aeYAxis = ['fuel', 'runningTime', 'ampere', 'voltage'];
export const aeYAxisCustom = [
  'fuel',
  'runningTime',
  'ampere',
  'voltage',
  'density',
  'volumeTotal',
  'volumeFlowRate',
  'massFlowRate',
  'massTotal',
  'temperature',
];
export const aeSchema = [
  {
    logKey: 'ae',
    dataKeys: ['fuelConsumption'],
    seriesOption: {
      name: 'Fuel Consumption',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.yellow,
      },
      lineColor: EChartColor.yellow,
      color: EChartColor.yellow,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['runningTime'],
    seriesOption: {
      name: 'Running Time',
      type: 'spline',
      yAxis: 1,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.black,
      },
      lineColor: EChartColor.black,
      color: EChartColor.black,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['ampere'],
    seriesOption: {
      name: 'Ampere',
      type: 'spline',
      yAxis: 2,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['voltage'],
    seriesOption: {
      name: 'Voltage',
      type: 'spline',
      yAxis: 3,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.teal,
      },
      lineColor: EChartColor.teal,
      color: EChartColor.teal,
    },
  },
];
export const aeSchemaCustom = [
  {
    logKey: 'ae',
    dataKeys: ['fuelConsumption'],
    seriesOption: {
      name: 'Fuel Consumption',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.yellow,
      },
      lineColor: EChartColor.yellow,
      color: EChartColor.yellow,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['runningTime'],
    seriesOption: {
      name: 'Running Time',
      type: 'spline',
      yAxis: 1,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.black,
      },
      lineColor: EChartColor.black,
      color: EChartColor.black,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['ampere'],
    seriesOption: {
      name: 'Ampere',
      type: 'spline',
      yAxis: 2,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['voltage'],
    seriesOption: {
      name: 'Voltage',
      type: 'spline',
      yAxis: 3,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.teal,
      },
      lineColor: EChartColor.teal,
      color: EChartColor.teal,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['density'],
    seriesOption: {
      name: 'Density',
      type: 'spline',
      yAxis: 4,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['volumeTotal'],
    seriesOption: {
      name: 'Volume Total',
      type: 'spline',
      yAxis: 5,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.blue,
      },
      lineColor: EChartColor.blue,
      color: EChartColor.blue,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['volumeFlowrate'],
    seriesOption: {
      name: 'Volume Flow Rate',
      type: 'spline',
      yAxis: 6,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['massFlowrate'],
    seriesOption: {
      name: 'Mass Flow Rate',
      type: 'spline',
      yAxis: 7,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.yellow,
      },
      lineColor: EChartColor.yellow,
      color: EChartColor.yellow,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['massTotal'],
    seriesOption: {
      name: 'Mass Total',
      type: 'spline',
      yAxis: 8,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.green,
      },
      lineColor: EChartColor.green,
      color: EChartColor.green,
    },
  },
  {
    logKey: 'ae',
    dataKeys: ['temperature'],
    seriesOption: {
      name: 'Temperature',
      type: 'spline',
      yAxis: 9,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.blueDark,
      },
      lineColor: EChartColor.blueDark,
      color: EChartColor.blueDark,
    },
  },
];

export const gatewayYAxis = [
  'cpuUsage',
  'memoryFree',
  'spaceFree',
  'signalStrength',
];
export const gatewaySchema = [
  {
    logKey: 'gateway',
    dataKeys: ['cpuUsage'],
    seriesOption: {
      name: 'CPU Usage',
      type: 'spline',
      yAxis: 0,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.pink,
      },
      lineColor: EChartColor.pink,
      color: EChartColor.pink,
    },
  },
  {
    logKey: 'gateway',
    dataKeys: ['memoryFree'],
    seriesOption: {
      name: 'Memory Free',
      type: 'spline',
      yAxis: 1,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.purple,
      },
      lineColor: EChartColor.purple,
      color: EChartColor.purple,
    },
  },
  {
    logKey: 'gateway',
    dataKeys: ['spaceFree'],
    seriesOption: {
      name: 'Space Free',
      type: 'spline',
      yAxis: 2,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.teal,
      },
      lineColor: EChartColor.teal,
      color: EChartColor.teal,
    },
  },
  {
    logKey: 'gateway',
    dataKeys: ['signalStrength'],
    seriesOption: {
      name: 'Signal Strength',
      type: 'spline',
      yAxis: 3,
      zIndex: 4,
      marker: {
        enabled: false,
        fillColor: EChartColor.black,
      },
      lineColor: EChartColor.black,
      color: EChartColor.black,
    },
  },
];
